export default "__VITE_ASSET__Chz$mjm3__"